/* ================ SLATE WINDOW ================ */

window.window = window.window || {};

window.cacheSelectors = function () {
  window.cache = {
    // General
    $window                  : $(window),
    $html                    : $('html'),
    $body                    : $('body'),
    windowHeight             : $(window).height(),


  };
};

window.init = function () {
  
  window.initInstaGrid();



};
window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (src === undefined){
      return null
    }
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      if ($(this.$container).find(this.singleOptionSelector).find("option").length < 1) {
        let currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
          let $element = $(element);
          let type = $element.attr('type');
          let currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        });
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = _.compact(currentOptions);

        return currentOptions;

      } else {
        let currentOptions = _.map($("#productSelect option", this.$container), function (element) {
          let $element = $(element);
          let type = $element.prop('nodeName').toLowerCase();
          let currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            if (type === "option") {
              if ($element.is(":selected") === true) {
                currentOption.value = $element.val();
                currentOption.index = 'option1';
              }
            } else {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
            }

            return currentOption;
          }
        });
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = _.compact(currentOptions);

        return currentOptions;
      }
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      if ($(this.$container).find(this.singleOptionSelector).find("option").length < 1) {
        var found = _.find(variants, function(variant) {
          return selectedValues.every(function(values) {
            return _.isEqual(variant[values.index], values.value);
          });
        });
        return found;
      } else {
        let found = "";
        selectedValues.forEach(values => {
          variants.forEach(variant => {
            if (found === "" && values.value === `${variant.id}`) {
              found = variant;
            }
          });
        });
        return found;
      }
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      if ($(".variant-quantity").length > 0) this._updateStockMessageDisplay(variant);
      this._updatePreOrderMessageBox(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateStockMessageDisplay: function(variant) {
      let current_variant = variantsJson.filter(variantObject => variantObject.id === variant.id)[0];
      $(".variant-sku").show().html(`<span>SKU:<span class="varSku">${current_variant.sku}</span></span>`);
      $(".variant-quantity").children().hide();
      if (current_variant.inventory_quantity > 3) {
        $(".in-stock-wrapper.normal").show();
        $(".product-form__cart-submit").prop('disabled', false);
        $(".product-form__cart-submit").text(theme.strings.addToCart);
      } else if (current_variant.inventory_quantity > 0) {
        $(".low-stock-wrapper").show();
        $(".product-form__cart-submit").prop('disabled', false);
        $(".product-form__cart-submit").text(theme.strings.addToCart);
      } else if (current_variant.inventory_policy === "continue") {
        if (current_variant.inventory_quantity <= 0 &&
          current_variant.inventory_policy === 'continue' &&
          current_variant.variantPreorderDate !== null) {
            $(".preorder-stock-wrapper").show();
            $(".product-form__cart-submit").prop('disabled', false);
            //$(".product-form__cart-submit").text("PRE-ORDER NOW");
            $(".product-form__cart-submit").text("ADD TO CART");
        } else {
          $(".in-stock-wrapper.oversell").show();
          $(".product-form__cart-submit").prop('disabled', false);
          $(".product-form__cart-submit").text(theme.strings.addToCart);
        }
      } else {
        $(".out-of-stock-wrapper").show();
        $(".product-form__cart-submit").prop('disabled', true);
        $(".product-form__cart-submit").text(theme.strings.soldOut);
      }
    },


    _updatePreOrderMessageBox: function(variant){
      let current_variant = variantsJson.filter(variantObject => variantObject.id === variant.id)[0];

      if (current_variant.inventory_quantity <= 0 &&
        current_variant.inventory_policy === 'continue' &&
        current_variant.variantPreorderDate !== null) {
          $(".preorder-variant-product .initial").hide();
          $(".preorder-variant-product .change").show();

          if(current_variant.variantPreorderDate != 'default' && current_variant.variantPreorderDate != '' ){
            $(".preorder-stock-wrapper .preorder-date").html(current_variant.variantPreorderDate);
          }
          else{
            $(".preorder-stock-wrapper .preorder-date").html(Shopify.preorder.preorderMessage);
          }
        }

        else{
          $(".preorder-variant-product .initial").hide();
          $(".preorder-variant-product .change").hide();
        }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if ( variant.compare_at_price != null && variant.compare_at_price != variant.price) {
        if (variant.compare_at_price === 0){
          $('.product-single [data-regular-price]').html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        } else {
          $('.product-single [data-regular-price]').html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        }
      }

      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }


    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
var selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };
  var cache = {};

 function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

//             if (!$el.hasClass(config.activeClass)) {
//         // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
//      }

//     showDropdown($el);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        
      });
    });

    // close dropdowns when on top level nav
    // cache.$topLevel.on('focus.siteNav', function() {
    //   if (cache.$activeDropdown.length) {
    //     hideDropdown(cache.$activeDropdown);
    //   }
    // });

// cache.$subMenuLinks.on('click.SiteNavLabel-shop', function(evt) {
//       // Prevent click on body from firing instead of link
//       evt.stopImmediatePropagation();
//     });
   
   $('#SiteNavLabel-shop').click(function(evt){
   		evt.stopImmediatePropagation();
   });
   $('header').click(function(evt){
   		evt.stopImmediatePropagation();
   });
    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
      
    });

    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);
	$('header').removeClass('bg-nav-click');
    $('.site-nav__link .icon-chevron-down').removeClass('arrow-click-up');
    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};
theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 990px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, ' + '0' + 'px, 0)'
      //transform: 'translate3d(0, ' + '36' + 'px, 0)'
    });


    slate.a11y.trapFocus({
      $container: cache.$mobileNav,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(-140%, 0px, 0)'
    });
    cache.$pageContainer.removeAttr('style');

    cache.$mobileNavContainer.one('TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle', function() {
      slate.a11y.removeTrapFocus({
        $container: cache.$mobileNav,
        namespace: 'navFocus'
      });
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $('.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]')
        .removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu[0].scrollHeight;
    if (!target) {
      translateMenuHeight = $targetMenu.outerHeight();
    }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    
    
    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);
    
    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one('TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle', function() {
      slate.a11y.trapFocus({
        $container: $targetMenu,
        $elementToFocus: $elementToFocus,
        namespace: 'subNavFocus'
      });

      cache.$mobileNavContainer.off('.subnavToggle');
      isTransitioning = false;
    });

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

//     $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
//       $(selectors.searchHeader).toggleClass(classes.focus);
//     });
	
//         $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('click', function() {
//       $(selectors.searchHeader).toggleClass(classes.focus);
//     });
    
    
    // $(selectors.siteHeaderSearchToggle).on('click', function() {
    //   var searchHeight = $(selectors.siteHeader).outerHeight();
    //   var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
    //
    //   $(selectors.searchDrawer).css({
    //     height: searchHeight + 'px',
    //     top: searchOffset + 'px'
    //   });
    // });
  }
  function is_touch_device() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function(query) {
      return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));
    if (is_touch_device){
      window.scrollTo(0,0);
    }
    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    if ($list){
      $list.removeAttr('aria-live');
    }


    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }


  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
//     $('.address-new-toggle').on('click', function() {
//       $newAddressForm.toggleClass('hide');
//     });

//     $('.address-edit-toggle').on('click', function() {
//       var formId = $(this).data('form-id');
//       $('#EditAddress_' + formId).toggleClass('hide');
//     });

  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();




window.initInstaGrid = function(){
  var instagramContainer = $('#instagrid');
  var accessToken = instagramContainer.attr('data-access-token');

  if (!instagramContainer.length || accessToken == null || !accessToken.length) return;

  window.instaGrid = new window.InstaGrid(accessToken);
}


/**
 * Whenever the user follows a link, have the site
 * fade to white.
 */
window.fadeOutOnClick = function(){

  //By setting up an Unload event we remove page caching
  //which makes the browser do a new HTTP request when
  //clicking the back button, instead of trying to
  //rebuild the page.
  window.onunload = function(e){
    // console.info("unload event:", e);
  };

  window.onpageshow = function(event) {
      if (event.persisted) {
          window.location.reload()
      }
  };


  var $overlay = this.cache.$fadeOutOverlay;
  var time = 300;
  var animation = 'ease';
  $('body').on('click', 'a', function(e){
    if (e.metaKey || e.shiftKey) return;
    var href = $(this).attr('href');
    //If it's a #, or starts with one, it's either an anchor or a dummy link.
    if (typeof href === 'undefined' || href === '#' || href.indexOf('#') === 0 || href.indexOf("mailto:") !== -1) return;
    if ($(this).attr('target') == "_blank") return;

    e.preventDefault();
    $overlay.addClass('show');

     setTimeout(function(){
        location.href = href;
    }.bind(this), time / 2)
  });

}


/*============================================================================
  InstaGrid
==============================================================================*/
window.InstaGrid = (function(){
  var InstaGrid = function(token){
    this.clientID = token;
    this.baseAPI = 'https://api.instagram.com/v1/';
    this.numberOfImages = 8; //This is the amount of visible image blocks, currently a max.
    this.maxImages = 8;
    this.imageIndex = this.numberOfImages; //track what # image to get from instagram
    this.$node = $('#instagrid');
    this.transitionSpeed = 1000; //ms
    this.instagramImageData = [];
    this.captionClassName = 'instagrid-caption';
    this.refreshTime =  2500; //ms
    this.randomize = true;
    this.loopAnimation = true;

    if (this.$node.length && this.clientID){
      this.init();
    }
  }

  InstaGrid.prototype.init = function() {
    this.authenticateWithAccessToken({
      'accessToken' : this.clientID,
      'feedType' : 'recent'
    })
    .then(function(images){
      this.insertImages(images);
      this.continuallyUpdateImages();
    }.bind(this))
    .fail(function(response){
      this.$node.remove();
      console.error("Could not instantiate Instagram Grid.", response);
    }.bind(this))
  };

  InstaGrid.prototype.getUserID = function(userName) {
    // 'https://api.instagram.com/v1/users/search?q=[USERNAME]&client_id=[CLIENT_ID]'
    var url = this.baseAPI + 'users/search?q='+userName+'&client_id='+this.clientID;
    url += '&callback=callbackFunction'; //make it a JSONP request
    var promise = jQuery.Deferred();

    $.ajax({
      'type' : 'GET',
      dataType : 'jsonp',
      data: {},
      url: url,
      success: function(data){
        if (typeof data.data === "undefined") {
          return promise.reject(data.meta);
        }
        var target = data.data.filter(function(e){
          return e.username === userName
        });
        promise.resolve(target[0].id)
      }.bind(this),
    });

    return promise.promise();

  };

  InstaGrid.prototype.authenticateWithAccessToken = function(options) {
    if (typeof options.feedType !== 'string'){
      options.feedType = 'recent';
    }


    var promise = jQuery.Deferred();
    var url = this.baseAPI + 'users/self/media/'+options.feedType+'?access_token=' + options.accessToken;

    $.ajax({
      'type' : 'GET',
      dataType: 'jsonp',
      data: {},
      url: url,
      success: function(response){

          if (! response) {
            promise.reject({code: 400, message: "No response from Instagram servers"});
          }

          if (response.meta.code === 400){
            promise.reject(response);
          }

          //any 2xx code
          if (response.meta.code === 200 || String(response.meta.code).indexOf('2') === 0 ) {
            this.instagramImageData = response.data;
            promise.resolve(response.data);
          }

          promise.reject(response);


      }.bind(this)
    });

    return promise.promise();


  };

  InstaGrid.prototype.insertImages = function(images){
    //We get the model/structure of the div from the markup, and just repeat it.
    var exampleDiv = this.$node.find('div:first').detach();
    var classes = exampleDiv[0].className;
    var allImages = [];

    //total number of visible/loaded images should
    //never exceed total available images.
    if (this.numberOfImages > images.length){
      this.numberOfImages = images.length;
    }

    images.forEach(function(image, i){
      if (i >= this.maxImages) return;

      var div = document.createElement('div');
      var src = image.images.standard_resolution.url;
      var imgWrapper = document.createElement('span');
      var img = document.createElement('img');
      var link = document.createElement('a');



      //When we transition the images, we fade between them, which requires
      //position absolute.  To make sure there the flow isn't modified,
      //we add a spacer element.
      //We have to wait to set the height of the element until the images
      //are loaded into the DOM, as currently the img height is 0px.
      var spacer = document.createElement('div');
      spacer.className = 'spacer'

      img.src = src;
      img.className = 'photo';
      div.className = classes;
      imgWrapper.className = 'image-wrapper';

      link.href = image.link;
      imgWrapper.appendChild(img);
      div.appendChild(imgWrapper);
      this.createAndAppendCaption(image, div);
      div.appendChild(link);

      allImages.push(div);
    }.bind(this))
    this.$node.append(allImages);
  }

  InstaGrid.prototype.createAndAppendCaption = function(image, target) {
    var caption = this.createCaption(image);
    return target.appendChild(caption);
  };

  InstaGrid.prototype.createCaption = function(image) {
    var caption = document.createElement('div');
    var likes = document.createElement('p');
    //Inline the svg.  Easier to create it this way then via createElement, as we'd also have to create the paths 1 by 1.
    var heart = $('<svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><title>0219-heart</title><desc>Created with Sketch.</desc><defs></defs><g id="Index-—-Presets" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Preset-4-—-Footer-1" sketch:type="MSArtboardGroup" transform="translate(-108.000000, -2697.000000)" fill="#FFFFFF"><g id="0219-heart-+-0-copy" sketch:type="MSLayerGroup" transform="translate(108.000000, 2696.000000)"><path d="M11.7993748,1 C10.1184373,1 8.67062483,2.38538538 8.00062484,3.83119748 C7.32906236,2.38538538 5.88124989,1 4.20031242,1 C1.88124996,1 0,2.90581446 0,5.25264907 C0,10.0276255 4.75843741,11.2795026 8.00062484,16.0003796 C11.0656248,11.3092414 15.9996872,9.87576773 15.9996872,5.25264907 C15.9996872,2.90581446 14.1187497,1 11.7993748,1 L11.7993748,1 Z" id="0219-heart" sketch:type="MSShapeGroup"></path></g></g></g></svg>')[0];
    var span = document.createElement('span');
    var text = document.createElement('p');

    caption.className = this.captionClassName;
    text.className = 'quote';
    span.className = 'count';
    likes.className = 'likes';

    var willImageHave = doesImageHaveCaption(image);

    if (willImageHave['text']){
      text.innerHTML =   image.caption.text;
    }

    if (willImageHave['likes']){
      var likesText = document.createTextNode(image.likes.count);
      span.appendChild(likesText);
    }

    likes.appendChild(span);
    likes.appendChild(heart);
    caption.appendChild(text);
    caption.appendChild(likes);
    return caption;
  };


  InstaGrid.prototype.replaceCaption = function(index, image) {
    var target = this.$node.children().eq(index);
    var captionSelector = '.instagrid-caption'
    var countSelector = captionSelector + ' .likes .count';
    var quoteSelector = captionSelector + ' .quote';
    var captionText = '';
    var likeCount = 0;
    var willImageHave = doesImageHaveCaption(image);

    if (willImageHave['text']){
      captionText = image.caption.text;
    }

    if (willImageHave['likes']){
      var likeCount = image.likes.count;
    }

    target.find(quoteSelector).text(captionText);
    target.find(countSelector).text(likeCount);

  };

  InstaGrid.prototype.replaceImage = function(index, image) {
    var nodes = this.$node.children();
    var target = nodes.eq(index);
    var link = target.find("a");
    var originalImg = target.find('img.photo');
    var newImg = document.createElement('img');
    var transitionCSS = this.transitionSpeed + 'ms ease-in-out';
    var instagramLink = image.images.standard_resolution.url;
    var source = image.link;

    //Set the new values
    link.attr('href', source);
    newImg.src = instagramLink;
    newImg.className = 'photo';

    //Fade the image out
    originalImg.css('transition', transitionCSS)
    .css('opacity', '0');

    //Remove the image once fade is done
    setTimeout(function(){
      originalImg.remove();
    }, this.transitionSpeed)

    //Add the replacement image
    $(newImg).css('position', 'absolute')
    target.children('.image-wrapper').prepend(newImg);

    this.replaceCaption(index, image);
  };

  //Updates the image (by index in grid) with the next image from instagram.
  InstaGrid.prototype.updateImages = function(index) {
    if (this.imageIndex >= this.instagramImageData.length - 1){

      if (! this.loopAnimation){
        return this.haltUpdatingImages();
      }

      this.imageIndex = 0;
    }

    var img = this.instagramImageData[this.imageIndex++];

    //If the image is a duplicate don't update it.
    var duplicates = this.$node.children().find("a").toArray().filter(function(e, i){
      return e.href === img.link;
    });

    if (duplicates.length){
      console.info("Duplicate image in InstaGrid, skipping it.");
      return;
    }

    this.replaceImage(index, img)
  };

  InstaGrid.prototype.continuallyUpdateImages = function() {
    var index = 0;

    if (this.instagramImageData.length <= this.maxImages){
      return; //No point in loading in new images if there aren't enough.
    }

    this.updateInterval = setInterval(function(){
      if (this.randomize){
        index = Math.floor( Math.random() * this.numberOfImages + 1 );
      }

      if (index >= this.numberOfImages) index = 0;
      this.updateImages(index++)
    }.bind(this), this.refreshTime)
  };

  InstaGrid.prototype.haltUpdatingImages = function() {
    clearInterval(this.updateInterval);
  };

  /*****************************
   * Private / Helper Functions
   ****************************/

  //returns an object with two bools, e.g. {text: false, likes: true},
  //which is truthy, or false, depending on results.
  //useful for the pattern:
  //  willImageHave = doesImageHaveCaption(image);
  //  if ( willImageHave['likes'] )...
  function doesImageHaveCaption(image){
    var likes = (! _.isNull(image.likes) && typeof image.likes.count === 'number' )
    var text = (! _.isNull(image.caption) && typeof image.caption.text === 'string' )

    if (! text && ! likes){
      return false;
    }

    return {text: text, likes: likes}
  }


  return InstaGrid;
})();




/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      // var sort = this._sortValue();
      // if (sort.length) {
      //   window.location.search = sort;
      // } else {
      //   // clean up our url if the sort value is blank for default
      //   window.location.href = window.location.href.replace(window.location.search, '');
      // }
      // this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      window.location.href = this.$filterSelect.val() + window.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '[data-sale-price]', //'#ComparePrice-' + sectionId,
      originalPrice: '[data-regular-price]', //'#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product__price .price', //'.product-price__price-' + sectionId,
      originalSelectorId: '#productSelect', // '#ProductSelect-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '#FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'price--on-sale', //'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '#productSelect' // '.single-option-selector-' + sectionId
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'));

    if (this.settings.zoomEnabled) {
      this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data('zoom'));
    }

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap));
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      if ($("#productSelect option").text().trim().toLowerCase().includes("default title")) {
        $(".variant-sku").show();
        $(".wrapper-clone").show();
      }
      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageSrc = $el.attr('href');
        var zoomSrc = $el.data('zoom');

        self._switchImage(imageSrc, zoomSrc);
        self._setActiveThumbnail(imageSrc);
      });
    },

    _setActiveThumbnail: function(src) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = $(this.selectors.productFeaturedImage).attr('src');
      }

      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(image, zoomImage) {
      $(this.selectors.productFeaturedImage).attr('src', image);

      // destroy image zooming if enabled
      if (this.settings.zoomEnabled) {
        _destroyZoom($(this.selectors.productImageWrap));
      }

      if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
        $(this.selectors.productImageWrap).data('zoom', zoomImage);
        _enableZoom($(this.selectors.productImageWrap));
      }
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      this._switchImage(sizedImgUrl, zoomSizedImgUrl);
      this._setActiveThumbnail(sizedImgUrl);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      if ( variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
      }
      else{
        $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      }

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(theme.Currency.formatMoney(variant.price, theme.moneyFormat))
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el) {
    var zoomUrl = $el.data('zoom');
    $el.zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom($el) {
    $el.trigger('zoom.destroy');
  }

  return Product;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
        }
      }.bind(this)
    );
  }

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      if ($list){
        $list.removeAttr('aria-live');
      }

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('product-recommendations', theme.ProductRecommendations);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  //slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

};

$(theme.init);




// Initialize window's JS on docready
$(window.init);



$(document)
  .on('shopify:section:load', function(event) {
    var section = $(event.target);
    var type = section.attr('class').replace('shopify-section', '').trim();

    window.initScrollTriggers();

    switch(type) {
    
   
    case 'instagram':
      window.initInstaGrid();
      break;
    
    }
  });

 module = {
    init: init
  };

// close mini when click continue shopping

$(document).ready(function(){
$("body").delegate(".ajaxcart .close-mini-cart", "click", function(){
    $('#CartDrawer .js-drawer-close').trigger('click');
});

$(document).ready(function() {
  var maxHeight = 0;
  $(".afterpay-how").find(".how-tabs").css({"height": "max-content"});
  $(".afterpay-how").find(".how-tabs").each(function() {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  var maxHeight = 0;
  $(".page-pay-later .afterpay-banners").css({"height": "max-content"});
  $(".page-pay-later .afterpay-banners").find("div").each(function() {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  //$(".afterpay-how").find(".how-tabs").css({"height": maxHeight.toString() + "px"});
  $(window).on('resize', function() {
    var maxHeight = 0;
    $(".afterpay-how").find(".how-tabs").css({"height": "max-content"});
    $(".afterpay-how").find(".how-tabs").each(function() {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $(".afterpay-how").find(".how-tabs").css({"height": maxHeight.toString() + "px"});
    });
  $(".page-pay-later .afterpay-faq .flex-layout").on('click', function() {
    $(this).siblings().slideToggle();
  });
});

});
// custom js.
$(function () {
  if ($('template-product')) {
    $('.product-template__container').removeClass('page-width');
    
    /* Align center for slick dots below product's thumbnails slider
    ================================================================*/
    
    var $dots = $('.template-product .slick-dots');
    var dotsWidth = $dots.width();
    $dots.css('left', 'calc((100% - ' + dotsWidth + 'px) / 2)');
    
    //Align center for sharing buttons
    var $sharing = $('.social-sharings');
    var sharingWidth = $sharing.width();
    $sharing.css('left', 'calc((100% - ' + sharingWidth + 'px) / 2)');
    
    //Product's specific tags
    var $navA = $('.nav-tabs li a');
    var $tabLi = $('.product-specific-tabs_desktop .tab-content div');
    
    $navA.click(function() {
      var $navA = $(this).parent();
      $navA.siblings().removeClass('active');
      $navA.addClass('active');
      var tabLink = $(this).attr('data-target').replace('#','');
      $tabLi.siblings().removeClass('active');
      $(".product-specific-tabs_desktop .tab-content div[id='"+tabLink+"']").addClass('active');
    });
    
    /*================================================================
    END Align center for slick dots below product's thumbnails slider */
    
    
    
    /* Click Shop blog post to trigger Add to Bag 
    ==============================================*/
    
//     $('.second-atc-button').click(function() {
//       $('.product-form__cart-submit').click();
//     });
    
    /*=============================================
    END Click Shop blog post to trigger Add to Bag */
    
    
    $(".certified_logo_below .description li[aria-controls='tabs-2']").addClass("ui-tabs-active, ui-state-active");
    $("#tabs-2").css('display','block');
    
    $('.product-single-container .slick-list').prepend("<div class='onsale-icon'>ON SALE</div>");
    
    
    /* Product Slideshow 
    ====================*/
    var $openSlider = $('.product-slideshow_open');
    $('.template-product').prepend('<div class="white-bg"></div>');
    
    var $whiteBg = $('.white-bg');
    $whiteBg.prepend('<div class="grey-bg"></div>');
    
    var $greyBg = $('.grey-bg');
    
    $whiteBg.css({
      'width': '100%',
      'height': '100%',
      'position': 'absolute',
      'z-index': '11',
      'background-color': 'white',
      'display': 'grid',
      'grid-template-columns': '100%',
      'grid-template-rows': '75% 25%',
      'grid-row-gap': '20px',
      'justify-items': 'center',
      'align-content': 'center',
      'display': 'none',
      'overflow': 'hidden'
    });
    
    $greyBg.css({
      'width': '100%',
      'height': '70%',
      'position': 'absolute',
      'z-index': '12',
      'background-color': '#f6f6f6'
    });

    var $newSlider = $('.product_slideshow-container');

    $newSlider
    .css({
      'display': 'block',
      'z-index':'13',
      'align-self': 'end'
    })
    .find('ul').css({
      'margin':'0 auto'
    }).click(function(e) {
      e.preventDefault();
    });
    
    var $sliderThumbnails = $('.product_slideshow-thumbnails');
    
    $sliderThumbnails
    .css({
      'display': 'block',
      'z-index':'13',
      'align-self': 'center'
    })
    .find('ul').css({
      'margin':'0 auto'
    }).click(function(e) {
      e.preventDefault();
    });
    
    var sliderCloseDiv = '<div class="slider_close"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 16.8 16.8" style="fill: #a5a5a5;"><path fill="#444" d="M16.8 1.5L15.4.1 8.4 7l-7-7L0 1.4l7 7-7 7 1.4 1.4 7-7 7 7 1.4-1.4-7-7z"></path></svg></div>'

    $whiteBg
    .prepend(sliderCloseDiv, $newSlider, $sliderThumbnails);

    $('.product_slideshow-container .product-img-slider').prepend($('.slick-prev-slider'));
    $('.product_slideshow-container .product-img-slider').append($('.slick-next-slider'));

    $openSlider.click(function(e) {
      e.preventDefault();
      window.scrollTo(0,0);
      $('body').css({
        'overflow':'hidden',
        'height': '100vh'
      });

      $whiteBg.css('display','grid').addClass('animated fadeIn');

      var $sliderClose = $('.slider_close');
      $sliderClose
      .css({
        'position': 'absolute',
        'justify-self': 'end',
        'top': '20px',
        'right': '20px',
        'z-index':'14'
      })
      .find('.icon-close').css({
        'fill': '#2e2e2e',
        'cursor': 'pointer'
      })
      .click(function() {
        $whiteBg.fadeOut();
        $('body').css({
          'overflow':'auto',
          'height': 'auto'
        });
      });
    });
    /*==================== 
    END Product Slideshow */
    
    
    
    /* Dynamic Header Menu 
    ======================*/
    var currentUrl = window.location.href;
    
    //Nav list
    var $navLi = $('.site-header .site-nav--left li');
    var $shop = $('.site-header .site-nav--left li:nth-child(2)');
    var $ourStory = $('.site-header .site-nav--left li:nth-child(3)');
    var $journal = $('.site-header .site-nav--left li:nth-child(4)');
    var $contactUs = $('.site-header .site-nav--left li:nth-child(5)');
    
    if (currentUrl.includes('collections')) {
      $navLi.siblings().removeClass('header-menu-active');
      $shop.addClass('header-menu-active');
      $('.site-nav__dropdown ul li a').css({
        'border': 'none',
        'color': '#2e2e2e'
      });
    } else if (currentUrl.includes('our-story')) {
      $navLi.siblings().removeClass('header-menu-active');
      $ourStory.addClass('header-menu-active');
    } else if (currentUrl.includes('blogs')) {
      $navLi.siblings().removeClass('header-menu-active');
      $journal.addClass('header-menu-active');
    } else if (currentUrl.includes('contact-us')) {
      $navLi.siblings().removeClass('header-menu-active');
      $contactUs.addClass('header-menu-active');
    }
    /*====================== 
    END Dynamic Header Menu */
    
    
    
    /* Change search button color 
    =============================*/
    
    var $searchBtn = $('.site-header__search');
    
    $searchBtn.click(function() {
      $('.button-search').css('color', '#f77500');
    });
    
    $('body').click(function(e) {
      if(!$(event?.target).closest('.button-search').length && $('.search-form-table').css('display') != 'block') {
        $('.button-search').css('color', 'black');
      }
    });
    
    /*============================= 
    END Change search button color */    
    
    
    
    /* Hide shop-by-range icon cart page 
    ====================================*/
    
    if($('.template-cart')) {
      $('.icon-paleo').hide();
    }
    
    /*=====================================
    END Hide shop-by-range icon cart page*/
  }
  
  
//     $("body").delegate(".ajaxcart .remove-product", "click", function(){
//       if (confirm('Are you sure you want to remove this item?')) {
//    			 $(this).parent('.grid').find('.ajaxcart__qty-num').val("val0").change();
//     }
   		
      
//   	});
});

 $(function () {
        $('.site-footer  .site-footer__linklist').slideUp();
        $('.linklist-title').click(function (event) {

            $(this).find('.fa').toggleClass('fa-minus');
            $(this).find('.fa').toggleClass('fa-plus');

            $(this).next().slideToggle();

        });

        $('.site-footer__linklist').toggleClass("footer-into-23");
    });

 // $('body').on('click', '.footer-info-list .fa-angle-down', function () {
 //     $(this).toggleClass('fa-angle-down');
 //     $(this).toggleClass('fa-angle-up');
 // });
 //
 //  $('.footer-info-list .fa-angle-down').click(function () {
 //        $(this).toggleClass('fa-angle-down');
 //        $(this).toggleClass('fa-angle-up');
 //    });

  
$(document).on('click', '#AddToCart', function(e) {
    $(".cart-link").trigger('click');
});
 
$( ".address-new-toggle" ).click(function() {
  $( "#AddressNewForm" ).toggleClass('hide');
});
 
$('.address-edit-toggle').on('click', function() {
  var $el2 = $(this);
  var formId2 = $(this).data('form-id');
  $('#EditAddress_' + formId2).toggleClass('edit-hide-2');
});
// $('.product-review-content').slideUp();
$('.product-detail-content').slideUp();
$('.product-toggle').on('click',function(){
	$(this).parent().next().slideToggle();
  	$(this).toggleClass('fa-minus');
    $(this).toggleClass('fa-plus');
  
});

$("body").delegate(".ajaxcart .remove-product", "click", function(){
      if (confirm('Are you sure you want to remove this item?')) {
        
        // $(this).parent('.grid').find('input.ajaxcart__qty-num').val("val0").change();
        
        // if($('body').hasClass('template-product')) {
          var $lineId = $(this).parents('.ajaxcart__row').data('line');
          console.log($lineId);
          ShopifyAPI.changeItem($lineId, 0, ajaxCart.load);
        //}
        
         
    }
   		
      
  	});

/************************* Mega Menu and Header *************************/
//Initialise mega menu, clone under parent link
$('.mega-menu[data-parent-link]').each(function() {
  var parentLink = $(this).data('parent-link');
  var $parentElement = $('#shopify-section-header2 .site-nav li[data-navlink-handle="' + parentLink + '"]');
  var $megaMenu = $(this).closest('.mega-menu__section');
  $parentElement.addClass('has-mega-menu');
  $parentElement.find('.mega-menu__section').remove();

  $megaMenu.clone().appendTo($parentElement);

  var $parentMobileElement = $('[data-mobile-menu-navlink-handle="' + parentLink + '"]');
  var $mobileElement = $('#MobileNav');
  $parentMobileElement.find('.submenu__label').addClass('has-mega-menu'); // Find data attribute for toggle and assign it true
  $mobileElement.after('<ul data-mobilesubmenu-handle="' + parentLink + '" class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>');

  /* Submenu is present - add mega menu elements and remove current sub-menu */
  var _$parentList = $('.mobile-nav-wrapper').find('[data-mobile-submenu-first-level-list][data-mobilesubmenu-handle="' + parentLink + '"]');
  _$parentList.empty().addClass('has-mega-menu'); // Insert mega menu
  $megaMenu.clone().appendTo(_$parentList);
    //services menu on mobile
$('[data-mobile-menu-navlink-handle="services"] .mobile-nav__dropdown').append($('[data-mobilesubmenu-handle="services"] .mega-menu__images-text'));

});

$('.mobile-nav-image').insertBefore($('.parentlink_accordion_on_mobile').first());
$('.megamenu-mobile').last().addClass('last');

$(".parentlink_accordion_on_mobile .mobile-nav__link").on("click", function (e) {
    $(this).parent().toggleClass('is-active');
    $(this).parent().find($('.mobile-nav__dropdown')).slideToggle();
});

$(".mega-menu__mobile-title").on("click", function (e) {
    $('body').find('.mobile-submenu__list').removeClass('active');
});


$('header .site-nav li')
.on('mouseover', function () {
    //Close any mega menus on hover
    $('.mega-menu__section').removeClass('is-active');
    $('body').removeClass('menu-is-active');

    if ($(this).hasClass('has-mega-menu')) {
        const childLink = $(this).data('navlink-handle');
        const $childElement = $('.mega-menu[data-parent-link="' + childLink + '"]').closest('.mega-menu__section');
        $(this).addClass('is-active');
        //Toggle corresponding mega menu
        $childElement.addClass('is-active');
        $('body').addClass('menu-is-active');
        //Add class active-menu to the trigger
        $(this).addClass('active-menu');
    }
}).on('mouseleave', function () {
    //Hide mega menu upon leaving mega menu, logo or navbar
    $('header .site-nav li').removeClass('is-active');
    $('.mega-menu__section').removeClass('is-active');
    $(this).removeClass('active-menu');
    $('body').removeClass('menu-is-active');
});

$(".submenu__label.has-mega-menu .mobile-nav__link").on("click", function (e) {
  e.preventDefault();
  var submenuHandle = $(this).closest('.mobile-nav__item').data('mobile-menu-navlink-handle');
  $('body')
      .find('.mobile-submenu__list[data-mobilesubmenu-handle="' + submenuHandle + '"]')
      .addClass('active');
});

$('#shopify-section-header2 .site-nav li').on("mouseover", function () {
  $('#AccessibleNav').addClass('nav-hover');
});

$('#shopify-section-header2 .site-nav li').on("mouseout", function () {
  $('#AccessibleNav').removeClass('nav-hover');
});


$(document).mouseup(function(e) {
    var container = $('.site-header__container .currency-dropdown-list');
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.hide();
      $('.site-header__container .active-currency').removeClass('is-active');
    }
});

//curency selector list toggle
$('.site-header__container .active-currency').on('click', function(){
  $(this).toggleClass('is-active');
  $('.site-header__container .currency-dropdown-list').toggle();
});

//currency selector trigger click
$('[data-currency-iso-code]').on('click',function(){
  var value = $(this).data('currency-iso-code');
  console.log(value);
  $('#currency_form select').val(value);
  $('#currency_form input').trigger('click');
});

$('#MobileNav, .mobile-submenu__list').on('click', function(e){
  e.stopPropagation();
});



if($(window).width() < 989){
    //mobile search position
  $('.site-header__menu.site-header__icon.search-icon-dummy').on('click', function(){
    $('#shopify-section-header2').removeClass('header-search-inactive');
  });

  $(window).scroll(function(e){
    if($('.autocomplete--visible').length > 0){
      e.preventDefault();
    }
    else{
      if ($(this).scrollTop() < 50) {
        $('#shopify-section-header2').removeClass('header-search-inactive');
      }
      else{
        $('#shopify-section-header2').addClass('header-search-inactive');
      }
    }
  });

  //mobile announcmenet bar
  $('.rotating-anouncement-bar').slick({
    dots: false,
    arrows:false,
    infinite: true,
    mobileFirst: true,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    draggable: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.announcement-bar__text p, .announcement-bar__text a').css('display','block');
}


    /************************* END Mega Menu & header *************************/
///scroll sticky header
  
  setTimeout(function(){
    if(document.documentElement.scrollTop || document.body.scrollTop > 20){
          }else{
            $( ".site-header" ).css( {"border-bottom":"none" } );
          }
  }, 300);
	
  	$( window ).scroll(function() {
       
      if(document.documentElement.scrollTop | document.body.scrollTop > 20){
      
//         $( ".site-header" ).css( {"background-color": "#fff","border-bottom":"none","transition":" .4s ease-in"} );
//         $( ".bc-sf-search-suggestion-mobile-top-panel form" ).css( {"background-color": "#7f7f7f","transition":" .4s ease-in"} );
        //$( ".site-header" ).css( {"background-color": "#fff","border-bottom":"#E7E1D7 solid 1px","transition":"background-color .4s ease-in"} );
        $( ".bc-sf-search-suggestion-mobile-top-panel form" ).css( {"background-color": "#7f7f7f","transition":"background-color .4s ease-in"} );      
   
      }else{
      	$( ".site-header" ).css( {"background-color": "","border-bottom":"none","transition":" .4s ease-in"} );
        $( ".bc-sf-search-suggestion-mobile-top-panel form" ).css( {"background-color": "#73706b","transition":" .4s ease-in"} );
      	 
      }
	});
$('.site-nav__link--button').click(function(){
	$('header').addClass('bg-nav-click');
  $('.site-nav__link .icon-chevron-down').addClass('arrow-click-up');
});

 
 $(".size-guide").click(function(){
    $("#sizeguide").fadeIn();
        $("#sizeguide").fadeIn("slow");
        $("#sizeguide").fadeIn(30000);
        $('body').attr({
          style: 'overflow: hidden;'
        });

});
$(".sizeguide #close").click(function(){
    $("#sizeguide").hide();
    $('body').attr('style', '');
});
$(".bgsize").click(function(){
    $("#sizeguide").hide();
    $('body').attr('style', '');
});

$(".product-description-content .sound-profile + p a").click(function(e){
  e.preventDefault();
  $("#soundprofile").fadeIn();
  $("#soundprofile").fadeIn("slow");
  $("#soundprofile").fadeIn(30000);
  $('body').attr({
    style: 'overflow: hidden;'
  });
});
$("#close").click(function(){
  $("#soundprofile").hide();
  $('body').attr('style', '');
});
$(".bgsize").click(function(){
  $("#soundprofile").hide();
  $('body').attr('style', '');
});

$(document).on('keyup',function(evt) {
    if (evt.keyCode == 27) {
      $("#soundprofile").hide();
       $("#sizeguide").hide();
       $("#puwhy").hide();
       $('body').attr('style', '');
    }
});
$(document).mouseup(function (e)
{

var container = $("#sizeguide");

if (!container.is(e.target) // if the target of the click isn't the container...
    && container.has(e.target).length === 0) // ... nor a descendant of the container
{
    container.hide();
}
});
$(document).mouseup(function (e)
{
var container = $("#puwhy");
if (!container.is(e.target) // if the target of the click isn't the container...
    && container.has(e.target).length === 0) // ... nor a descendant of the container
{
    container.hide();
}
});
$("#xclose").click(function(){
    $("#puwhy").hide();
});
$(".bgsize").click(function(){
    $("#puwhy").hide();
});

//menu click tab
 $('.tab-click').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.tab-click').removeClass('current');
   $('.tab-click').parent().removeClass('add-active');
    $('.child-link-ul').removeClass('current');

    $(this).addClass('current');
   $(this).parent().addClass('add-active');
    $("#"+tab_id).addClass('current');
  })   
  	
// marked by Rengie
$(document).ready(function(){
  $( "body" ).delegate( "button.bc-addtocart-available", "click", function() {
        var obj = $(this);
        var formId = obj.attr('form-id');
        // separated handler for ss add to cart in minicart
        if (obj.parents('#CartDrawer').length) {
          var closestWrapper = obj.closest('.bc-action-list-wrapper')
          var checkForm = closestWrapper.find('#'+formId)
          var varID = closestWrapper.find("input[name='id']").val()
          var ajaxAddObj = {
            items: [
              {
                id: varID,
                quantity: 1
              }
            ]
          }
          obj.find('span').html('Adding...');
          obj.attr('disabled', 'disabled');
          $.post( "/cart/add", ajaxAddObj)
          .done(function( data ) {
            obj.find('span').html('Add to Cart');
            obj.removeAttr('disabled');
            ShopifyAPI.getCart(ajaxCart.load);

            // Workaround to refresh SearchSpring Content
            // This enables SearchSpring Content to be loaded
            $('.ss_recs_cart').click();
          });
        }
        // all other ss add to cart
        else {
          obj.find('span').html('Adding...');
          obj.attr('disabled', 'disabled');
          $.post( "/cart/add.json", jQuery('#'+formId).serialize())
          .done(function( data ) {
            $('.js-drawer-open-right').click();
            obj.find('span').html('Add to Cart');
            obj.removeAttr('disabled');

            // Workaround to refresh SearchSpring Content
            // This enables SearchSpring Content to be loaded
            $('.ss_recs_cart').click();
          })
          .fail(function(xhr, status, error) {
            let jsonResponse = JSON.parse(xhr.responseText);
            alert(jsonResponse.errors);
            obj.find('span').html('Add to Cart');
            obj.removeAttr('disabled');
          });
        }
        return false;
    });
});


$( ".mobile-nav--open").click(function() {
$('html').toggleClass('js-drawer-open');
 $('body').toggleClass('js-drawer-open');
 $('#shopify-section-header2').toggleClass('js-drawer-open');
});

$( "body").click(function() {
  $( "button.mobile-nav--close .icon-close").trigger('click');
  $("button.mobile-nav--close").trigger("click");
});

//close mobile nav when wihslist link is clicked
$('.wishlist-link').on('click', function(){
  $("button.mobile-nav--close").trigger("click");
});


$('select#Quantity').on('change', function() {
  $('input#Quantity').val( this.value );
});

$('.js-toggle-submenu').click(function(){
     $('.menu-mobile').addClass('abc4');
});
$('.mobile-link-1').click(function(){
     $('.menu-mobile').removeClass('abc4');
});
var page = location.href;
$('.blog-post-detail-text a[href="' + page + '"]').parent().addClass('active');
// if($('.product-size-option')){
//      $('#AddToCart').attr("id","AddToCart1");
// }
  if ($('.product-size-option')[0]) {
  $('.product-check-option').attr("id","AddToCart1");
}
$("#productSelect").change(function(){
	$('#AddToCart1').attr("id","AddToCart");
	
});
  if ($('.product-size-option1')[0] && !$('.product-size-option1').val()) {
$('.product-check-option').attr("id","AddToCart1");
}




$(document).ready(function(){
      $('.image-product').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        adaptiveHeight: true,
        asNavFor: '.slider-nav'
      });

      $('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.image-product',
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        verticalReverse: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 3,
              vertical: false,
              verticalSwiping: false,
              verticalReverse: false,

            }
          }
        ]
      });

      $('.slider-nav1').slick({

        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.image-product',
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        verticalReverse: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 3,
              vertical: false,
              verticalSwiping: false,
              verticalReverse: false,
              dots: false
            }
          }
        ]
      });

      const slider = $(".slider-nav");
      slider.on('wheel', (function(e) {
        e.preventDefault();

        if (e.originalEvent.deltaY < 0) {
          $(this).slick('slickNext');
        } else {
          $(this).slick('slickPrev');
        }
      }));

  $('.slider-product img').addClass('img-slider');
  $('.product-single__photos').css('visibility', 'visible');
});



// Search bar animation

// $('.search-header__input').keyup(function() {
//   if($(this).val().trim().length != 0) {
//     $("body").addClass('autocomplete-search');
//     $(".site-header").addClass('Site-heade');
//   }
//   else {
//     $("body").removeClass('autocomplete-search');
//     $(".site-header").removeClass('Site-heade');
//   }
// });

// $('.algolia-autocomplete').click(function(e) {
//     e.stopPropagation();
// });

// $("body").click(function() {
//   	if($(this).hasClass('autocomplete-search')) {
//       $(this).find('.search-header').removeClass('search--focus');
//       $("body").removeClass('autocomplete-search');
//       $(".site-header").removeClass('Site-heade');
//       $(".search-header__input").blur();
//     }
// });

// $(".search-header__input").on("click",function(){
//   $(this).parent().addClass("search--focus");
//   $(this).next(".icon-search").css('color',"#fff");
//   if(window.innerWidth > 749) {
//     $('body').addClass('autocomplete-search');
//     $(".site-header").addClass('Site-heade');
//   }
// });

// $(".search-header__input").on("blur",function(){
//     $("body").removeClass('autocomplete-search');
//     $(".site-header").removeClass('Site-heade');
//     $("#search-form-head").removeClass("search--focus");
// });

// $('.search-header__submit').click(function() {
//     $(this).parent().removeClass('search--focus');
//     $('body').removeClass('autocomplete-search');
//     $(".site-header").removeClass('Site-heade');
// });

// $('.site-header__icon').click(function() {
//     $("body").removeClass('autocomplete-search');
  
// });

  
// $('.site-header__icon').on('click', function(){
//   if ($(this).parent().hasClass('search--focus')){    
//         $(".site-header").addClass('Site-heade');
//   }
// });
$(".search-header__input").on("click",function(){
  $("#search-form-head").addClass("searchform--focus");
  if ($(this).val().length == 0) {
    setSearchDropdownStyle();
    $("#search-form-head").addClass("no-text");
  } else {
    $(".aa-empty-search").hide();
    $("#search-form-head").removeClass("no-text");
  }
});

$(".search-header__input").on("blur",function(){
    if ($(this).val().length == 0) {
      $("#search-form-head").addClass("no-text");
    } else {
      $("#search-form-head").removeClass("no-text");
    }
    setTimeout(function(){
      $(".aa-empty-search").hide();
      $('html').removeClass('autocomplete--visible');
      if ($(this).val().length == 0) {
        $("#search-form-head").removeClass("searchform--focus");
      }
    }, 300);
});

if (navigator.userAgent.match(/iPhone|iPad|iPod/i) && window.innerWidth < 750) {
  $('body').addClass('isIOSmobile');
}

$(".search-header__input").on("keyup input change",function(){
  $(".aa-empty-search").hide();
  if ($(".search-header__input").val().length == 0) {
    $("#search-form-head").addClass("no-text");
    $('html').removeClass('autocomplete--visible');
  } else {
    $("#search-form-head").removeClass("no-text");
  }
});

$(window).on('resize', function() {
  setTimeout(function() {
    if ($(".search-header__input").val().length == 0 && !$(".aa-empty-search").is(':visible')) {
      $('html').removeClass('autocomplete--visible');
    }
    
    if ($(".algolia-autocomplete").is(':visible')) {
      setSearchDropdownStyle('resize');
    }
  }, 250);
});

 $('.site-header__icon').on('click', function(){
if ($(".search--focus")[0] && document.documentElement.scrollTop ){
   $(".site-header").addClass('Site-heade');
}
 });

function setSearchDropdownStyle(type) {
  // set top position
  var $el = $('#search-form-head');
  var eTop = $el.offset().top;
  var topPosition = eTop - $(window).scrollTop() + $el.outerHeight(true);

  $(".aa-empty-search").css('top',topPosition+'px');

  // set max-height
    if ($('body').hasClass('isIOSmobile')) {
      var maxHeight = 'calc(60vh - ' + topPosition + 'px - 110px )';
    }
    else{
      var maxHeight = 'calc(100vh - ' + topPosition + 'px - 110px )';
    }
    var aaFooter = $(".algolia-autocomplete").find('.aa-footer a').html();
    var aaFooterLink = $(".algolia-autocomplete").find('.aa-footer a').attr('href');
    $(".algolia-autocomplete .aa-left-column").css('max-height',maxHeight);
    $(".algolia-autocomplete")
      .find('.aa-view-all-js')
      .remove();
      if(aaFooter != undefined){
        $(".algolia-autocomplete:not(.aa-empty-search) .aa-columns-container").append('<a href="' + aaFooterLink + '" class="aa-view-all-js">' + aaFooter + '</a>');
      }
      else{
        $(".algolia-autocomplete")
        .find('.aa-view-all-js')
        .remove();
      }
    $(".algolia-autocomplete").find(".aa-product-price").each(function() {
      var price = parseFloat($(this).text().replace('$','')).toFixed(2);
      $(this).text('$' + price);
    });

  // set left position
  if($(window).width() <= 798) {
    var leftOffset = 0;//10;
  } else {
    var leftOffset = 0;//30;
  }
  var leftPosition = $('#search-form-head').offset().left - leftOffset;
  leftPosition.toFixed(0);
    
  if($(window).width() <= 749) {
    leftPosition = 10;
  }
  
  $(".algolia-autocomplete").css('left',leftPosition);

  // show dropdown
  if (type != 'resize') {
    $(".aa-empty-search").show();
    $('html').addClass('autocomplete--visible');
  }
}

$("body").click(function() {
$(".site-header").removeClass('Site-heade');
});

//    $(".filters-toolbar__input--sort").change(function() {
// 	$( ".filters-toolbar__input--sort option:selected" ).each(function() {
//       		$('.filters-toolbar__input--sort').addClass('fdgfdg');
//     });
	
// });
   
$("select#productSelect").on('change',function () {
  var price = '';
  $("select#productSelect option:selected").each(function () {
    price = $(this).data('price');
  });
   $('.price-item').text(price);
})
$(".mobile-nav__slideup").slideUp();
$(".mobile-nav__slidetoggle").on("click",function(){
	$(this).next().slideToggle();
    $(this).find('.mobile-nav__icon').toggleClass('toggle-icon');
  

});
 
   
   if ($('.p-badge-img')) {
   		$(".p-badge-img").parent().next().find('.price-item__label').addClass('badge-sale-down');
     }

 
$('.bc-sf-filter-option-block .bc-sf-filter-block-title a').removeClass('selected');


     
  $(function() {
 

$('.bc-sf-filter-block-content').css('display','none');
  
  //prevent mobile sidebar filters hidden on load
  $('.bc-custom-filter-sidebar-wrapper .bc-sf-filter-block-content').css('display','block');
  });

jQuery('#soundprofile').insertBefore('#PageContainer');
jQuery('#sizeguide').insertBefore('#PageContainer');
jQuery('#puwhy').insertBefore('#PageContainer');



$(function(){
  
  var dropDownMenu = $('.site-nav__dropdown');
  var dropDownMenuHeight = dropDownMenu.height() + 130;

  var windowHeightResize = function() {
      if ($(window).height() < dropDownMenuHeight) {
          dropDownMenu.addClass('short-viewport');
      } else {
          dropDownMenu.removeClass('short-viewport');
      }
  };

  windowHeightResize();

  var delay = (function(){
      var timer = 0;
      return function(callback, ms){
          clearTimeout (timer);
          timer = setTimeout(callback, ms);
      };
  })();

  $(window).on('resize', function () {
      delay(function(){
          windowHeightResize();
          moveInfiniteoption();
      }, 400);
  });
});

function moveInfiniteoption () {
  const $elem = $('#infiniteoptions-container');
  const $targetMobContainer = $('.product-add-to-cart.product-add-to-cart-mb').find('form');
  const $targetDesContainer = $('.product-add-to-cart.product-add-to-cart-destop').find('form');
  if(window.innerWidth < 750) {
    $targetMobContainer.prepend($elem);
  } else {
    $targetDesContainer.prepend($elem)
  }
}

moveInfiniteoption();

$(document).ready(function() {
  $(".wishlistForm #wishlistButton").each(function() {
    if ($(this).hasClass("swym-added") || $(this).hasClass("disabled")) {
      $(this).attr("trigger", "1");
      $(this).children().each(function() {
        if ($(this).hasClass("icon-heart-solid")) {
          $(this).css({
            "display": "block",
            "background-color": "#e66659"
          });
        }
        if ($(this).hasClass("icon-heart")) {
          $(this).css({
            "display": "none"
          });
        }
      });
    } else {
      $(this).attr("trigger", "0");
      $(this).children().each(function() {
        $(this).removeAttr('style');
      });
    }
    $(this).on('click', function() {
      //if ($(this).attr("trigger") === "0") {
      if ($(this).hasClass("swym-added") || $(this).hasClass("disabled")) {
        $(this).children().each(function() {
          $(this).removeAttr('style');
        });
        $(this).attr("trigger", "0");
      } else {
        $(this).children().each(function() {
          if ($(this).hasClass("icon-heart-solid")) {
            $(this).css({
              "display": "block",
              "background-color": "#e66659"
            });
          }
          if ($(this).hasClass("icon-heart")) {
            $(this).css({
              "display": "none"
            });
          }
        });
        $(this).attr("trigger", "1");
      }
    });
  });
});

// instrument product template product details nav/accordion
$('.product-description-nav-item').click(function() {
  $('.product-description-nav-item').removeClass('description-nav--active');
  $('.product-description-content-item').removeClass('description-content--active');
  if($(this).hasClass('product-description-nav-description')) {
    $(this).addClass('description-nav--active');
    $('.product-description--description').addClass('description-content--active');
  }
  if($(this).hasClass('product-description-nav-features')) {
    $(this).addClass('description-nav--active');
    $('.product-description--features').addClass('description-content--active');
  }
  if($(this).hasClass('product-description-nav-ready')) {
    $(this).addClass('description-nav--active');
    $('.product-description--ready').addClass('description-content--active');
  }
  if($(this).hasClass('product-description-nav-shipping')) {
    $(this).addClass('description-nav--active');
    $('.product-description--shipping').addClass('description-content--active');
  }
});

$('.product-description-content-item').click(function(e) {
  if($(window).width()< 768) {
    if(e.target.matches('.product-description-mobile-nav')) {
      if($(this).hasClass('description-content-mobile--active')) {
        $(this).removeClass('description-content-mobile--active');
      }
      else {
        $(this).addClass('description-content-mobile--active');
      }
    }
  }
});

function instrumentProductPagePayment() {
  $('.instrument-product-finance-payment').find('.afterpay').find('svg').click(function() {
    const target_shadowRoot = document.getElementsByClassName('product-instrument-payment')[0].querySelector('square-placement').shadowRoot;
    $(target_shadowRoot).find('.afterpay-link').get(0).click();
  });
  $('.instrument-product-finance-payment').find('.zip').find('svg').click(function() {
    const target_zip_popup = document.getElementsByClassName('product-instrument-payment')[0].querySelector('.zip-widget__wrapper');
    document.getElementsByClassName('product-instrument-payment')[0].querySelector('.zip-widget__wrapper').click();
    target_zip_popup.click();
  });
}

instrumentProductPagePayment();



$(document).on('click', '.instrument-product-finance-payment .afterpay svg', function() {
  const target_shadowRoot = document.getElementsByClassName('product-instrument-payment')[0].querySelector('square-placement').shadowRoot;
  $(target_shadowRoot).find('.afterpay-link').get(0).click();
});


$(document).arrive('.product-single .spr-badge-caption', function() {

  //product page reviews anchor link
  var headerHeight = $('header').height();
  if($('.page-width-header').length > 0){
    headerHeight += $('.page-width-header').height();
  }

  $('.product-single .spr-badge-caption').on('click', function(){
    $('html, body').animate({
        scrollTop: $('#product-review-section').offset().top - headerHeight
    }, 500);
  });

  //product page reviews score
  var reviewScore = $('#product-review-section .spr-badge').attr('data-rating');
  reviewScore = parseFloat(reviewScore).toFixed(1);
  if(reviewScore > 0){
    $('#product-review-section .spr-badge').prepend('<div class="review-score">' + reviewScore +'</div>');
  }
});

//category landing pages
$(document).ready(function() {
  $('.category-landing-instrument-preview .instrument-preview-carousel').slick({
    dots: true,
    arrows: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '92px',
    infinite: true,
    rows: 0,
    autoplay: false,
    adaptiveHeight: true,
    variableWidth: true,
    prevArrow: '<button class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Prev.</span></button>',
    nextArrow: '<button class="slick-next"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Next.</span></button>',
    responsive: [
        {
          breakpoint: 1600,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '45px',
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });
  
  carouselDescriptionShorten();

  $(window).resize( ()=>{
    carouselDescriptionShorten();
  }).resize();
});

$(document).ready(function() {
  $('.category-landing-blogs .blog-carousel').slick({
    dots: true,
    arrows: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '90px',
    infinite: true,
    rows: 0,
    autoplay: false,
    variableWidth: true,
    prevArrow: '<button class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Prev.</span></button>',
    nextArrow: '<button class="slick-next"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Next.</span></button>',
    responsive: [
        {
          breakpoint: 1600,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '45px',
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });
  carouselDescriptionShorten();
  $(window).resize( ()=>{
    carouselDescriptionShorten();
  }).resize();
});

$(document).ready(function() {
  $('.category-landing-best-selling .best-selling-carousel').slick({
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    infinite: false,
    autoplay: false,
    rows: 0,
    variableWidth: true,
    prevArrow: '<button class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Prev.</span></button>',
    nextArrow: '<button class="slick-next"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Next.</span></button>',
    responsive: [
        {
          breakpoint: 1600,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              rows: 0
          }
        },
        {
          breakpoint: 768,
          settings: {
              centerMode: true,
              centerPadding: '45px',
              variableWidth: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true
          }
        },
        {
          breakpoint: 476,
          settings: {
              centerMode: true,
              centerPadding: '45px',
              variableWidth: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
          }
        }
      ]
  });

  changePlaceholder();
});

function changePlaceholder() {
  if ($(window).width() < 800) {
      $("#bc-sf-search-box-1").attr("placeholder", "Search for Violins, Cellos, Strings and More...");
  }
  else {
      $("#bc-sf-search-box-1").attr("placeholder", "Search for Violins, Violas, Cellos and More...");
  }
}

$(window).resize(function () {
  changePlaceholder();
});

$(".category-landing-page .faq-item .faq-question").on('click', function() {
  $(this).toggleClass('active');
  $(this).siblings().slideToggle();
});

$(".collection-faqs .faq-item .faq-question").on('click', function() {
  $(this).toggleClass('active');
  $(this).siblings().slideToggle();
});

function carouselDescriptionShorten () {
  var showChar = 245;  // character limit
  var ellipses = '...';

  if($(window).width() < 768){
    showChar = 155;  // mobile character limit
  }

  $('.category-landing-page .slick-list .card').each(function() {
    var content = $(this).find('.article-excerpt').text();
    if(content.length > showChar) {
      var visibleContent = content.substr(0, showChar);
      var html = visibleContent + ellipses;
      $(this).find('.article-excerpt').html(html);
    }
  });
}

// if($('.category-landing-page .section-header-description p').length > 0){
//   let content = $('.category-landing-page .section-header-description p');
//   headingDescriptionShorten(content);
// }


// if($('.category-page .collection-description').length > 0){
//   if($(window).width() < 768){
//     if($('.category-page .collection-description p').length > 0){
//       let content = $('.category-page .collection-description .description p');
//       headingDescriptionShorten(content);
//     }
//     else{
//       let content = $('.category-page .collection-description .description');
//       headingDescriptionShorten(content);
//     }

//   }
//   else{
//     if($('.category-page .collection-description p').length > 0){
//       let content = $('.category-page .collection-description .description p');
//       headingDescriptionShorten(content, 600);
//     }
//   }
// }

// function headingDescriptionShorten(content, limit) {
//   var showChar = limit; // character limit predefined


//   if(limit == null){
//     showChar = 445;  // character limit desktop
//   }

//   var ellipses = '...';
//   var readMore = 'Read More.';
//   var readLess = 'Read Less.';

//   if($(window).width() < 768){
//     showChar = 123;  // character limit mobile
//   }

//     content.each(function() {
//       var content = $(this).text();

//       if(content.length > showChar) {
//         var visibleContent = content.substr(0, showChar);
//         var hiddenContent = content.substr(showChar, content.length - showChar);
//         var html = visibleContent + '<span class="more-ellipses">' + ellipses+ '</span><span class="more-content"><span>' + hiddenContent + '</span>&nbsp;&nbsp;<a href="" class="more-link">' + readMore + '</a></span>';
//         $(this).html(html);
//       }
//     });

//   $('.more-link').click(function(){
//     if($(this).hasClass('less')) {
//       $(this).removeClass('less');
//       $(this).html(readMore);
//     } else {
//       $(this).addClass('less');
//       $(this).html(readLess);
//     }
//     $(this).parent().prev().toggle();
//     $(this).prev().toggle();
//     return false;
//   });
// }


console.log('Start v12');
(function ($) {
  console.log('[ReadMore] script loaded');

  function init($root) {
    $root.find('.description').each(function () {
      var $desc = $(this);
      if ($desc.data('rm-init')) return;
      if ($desc.find('.read-more, .more-link, [for^="so-tab"]').length) return; // skip if custom readmore exists

      // Optional move: only move inner content of .top-content, append to .collection-hero
      var $top = $desc.find('.top-content').first();
      var $hero = $('.collection-hero').first();
      if ($top.length && $hero.length) {
        var $kids = $top.contents(); // only children, not the wrapper
        if ($kids.length) {
          var $wrap = $('<div style="margin-top: 20px;text-align:center;" class="moved-top-content"></div>');
          $wrap.append($kids);
          $hero.append($wrap);
          $top.remove();
          console.log('[ReadMore] moved .top-content into .collection-hero');
        }
      }

      // Recompute first paragraph after any move
      var $paras = $desc.find('p');
      if ($paras.length <= 1) return; // skip if only one paragraph

      var $firstP = $paras.first();

      // Hide everything after the first paragraph, then insert the toggle link
      $firstP.nextAll().hide();
      $('<a style="display:block;margin-bottom:30px;" href="" class="more-link">Read More</a>').insertAfter($firstP);

      $desc.data('rm-init', 1);
    });
  }

  $(function () {
    init($(document));
    console.log('[ReadMore] init complete');
  });

  document.addEventListener('shopify:section:load', function (e) {
    init($(e.target));
    console.log('[ReadMore] re-init after section load');
  });

  // Toggle handler
  $(document).off('click.rm').on('click.rm', '.description .more-link', function (e) {
    e.preventDefault();
    var $a = $(this);
    var $desc = $a.closest('.description');
    var $firstP = $desc.find('p:first');

    if ($a.hasClass('less')) {
      // Collapse: keep the link visible
      $firstP.nextAll(':not(.more-link)').hide();
      $a.removeClass('less').text('Read More');
      console.log('[ReadMore] collapsed');
    } else {
      // Expand: show all including non-paragraph nodes
      $firstP.nextAll().show();
      $a.addClass('less').text('Read Less');
      console.log('[ReadMore] expanded');
    }
  });
})(jQuery);



//Refresh cart for Schopify scripts Product Discounts by Customer Tag in account page
/*
if(location.href.includes('/account')){

  cartUpdateCallback = function (cart) {

    $.each(cart.items, function(index, cartItem) {
      ShopifyAPI.changeItem(index + 1, cartItem.quantity);
    });
  };

  ShopifyAPI.getCart(cartUpdateCallback);
}

$('a[href^="/account/logout"]').on("click", function() {
  $.ajax( $(this).attr('href') )
    .done(function() {

      cartUpdateCallback = function (cart) {
        $.each(cart.items, function(index, cartItem) {
          ShopifyAPI.changeItem(index + 1, cartItem.quantity);
        });
      };
      ShopifyAPI.getCart(cartUpdateCallback);

      setTimeout(function() {
        window.location.href = "/";
      }, 500);

    });
  return false;
});
*/

//adjust header and main content padding if hellobar exists
$(document).ready(function() {
  
  $('.collection-img').click(function(){
	 var getUrl = $(this).parent().find('.child-link').attr('href');
     location.assign(getUrl);
  });






  
  //algolia instant search page filters
  $(window).load(function() {
    if($(window).width() <= 992){
      //create new wrapper around filters button
      $('.ais-facets-button').wrap( "<div class='ais-facets-button-wrapper'></div>" );

      //move sort filter into the wrapper created above
      $('.ais-page .ais-facets-button-wrapper').append($('.ais-page .ais-sort'));

      //create drawer overlay in search result page
      $('.ais-page').append("<div class='drawer-overlay'></div>");

      //open drawer + show overlay when filters button is clicked
      $('.ais-facets-button').on('click', function(e){
        e.preventDefault();
        $('.ais-page .ais-facets').addClass('ais-facets__shown');
        $('.ais-page .drawer-overlay').addClass('active');
        $(this).text('Show filters');
      });


      //close drawer + hide overlay when overlay or close button is clicked
      $('.ais-page .drawer-overlay, .ais-current-refined-values--header.ais-facet--header.ais-header').on('click', function(e) {
        e.preventDefault();
        $('.ais-page .ais-facets').removeClass('ais-facets__shown');
        $('.ais-page .drawer-overlay').removeClass('active');
      });


      //toggle menu sections in drawer
      $('.ais-facet--header.ais-header:not(.ais-current-refined-values--header)').on('click', function(e){
        $(this).toggleClass('up');
        $(this).siblings('.ais-facet--body').slideToggle();
      });
    }

    else{
      //create new wrapper around facets
      $('.ais-facets').wrap( "<div class='ais-facets-wrapper'></div>" );

      //insert refined values section after facets
      $('.ais-current-refined-values-container').insertAfter($('.ais-facets-wrapper'))

      //move sort filter with facets
      $('.ais-page .ais-facets-wrapper .ais-facets').append($('.ais-sort'));


      //toggle facet
      $('.ais-facet--header.ais-header').on('click', function(e){
        $('.ais-facet--header.ais-header').not(this).removeClass('active-facet-category');
        $('.ais-facets .ais-facet--body').not($(this).siblings('.ais-facet--body')).hide();

        $(this).toggleClass('active-facet-category');
        $(this).siblings('.ais-facet--body').toggle();
      });

      $(document).click(function(e) {
        const $target = $(e.target);

        if($target.closest($(".ais-facets .ais-facet--body")).length > 0){
          $target.closest($(".ais-facet--header.ais-header")).addClass('active-facet-category');
          $target.closest($(".ais-facets .ais-facet--body")).show();
        }

        else if (!$target.closest(".ais-header").length && $(".ais-facet--header.ais-header.active-facet-category").length) {
          $(".ais-facet--header.ais-header.active-facet-category").removeClass("active-facet-category");
          $(".ais-facets .ais-facet--body").hide();
        }

      });

    }

    $('.ais-facets-button-wrapper, .ais-facets-button, .ais-facets').css('visibility', 'visible');

  });
});

//“On Demand” YouTube loading for Youtube embeds
$(document).ready(function() {
  initYouTubeVideos();
});

function labnolIframe(div) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute(
    'src',
    'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1&rel=0'
  );
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute(
    'allow',
    'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
  );
  div.parentNode.replaceChild(iframe, div);
}

function initYouTubeVideos() {
  var playerElements = document.getElementsByClassName('youtube-player');
  for (var n = 0; n < playerElements.length; n++) {
    var videoId = playerElements[n].dataset.id;
    var div = document.createElement('div');
    console.log(videoId);
    div.setAttribute('data-id', videoId);
    var thumbNode = document.createElement('img');
    thumbNode.src = '//i.ytimg.com/vi/ID/hqdefault.jpg'.replace(
      'ID',
      videoId
    );
    div.appendChild(thumbNode);
    var playButton = document.createElement('div');
    playButton.setAttribute('class', 'play');
    div.appendChild(playButton);
    div.onclick = function () {
      labnolIframe(this);
    };
    playerElements[n].appendChild(div);
  }
}


//SellUp app custom logic
$(document).arrive(".dynamic_title_upsell", function () {
  var productTitles = [];
  var productHandles = [];

  //add product title to modal
  $("#launchtip_upsell_wrapper .detail_title .title").each(function () {
    if ($(this).closest($(".productbox")).find($(".launchtipsellupform")).length > 0) {
      productTitles.push($(this).text());
    }
  });

  $("#launchtip_upsell_wrapper .launchtipsellupform .detail_price").each(
    function (index) {
      $(this).before(`<div class="product-title">${productTitles[index]}</div>`);
    }
  );

  //check if upsell products in cart on load, if they are change the icons
  $.getJSON("/cart.js", function (cart) {
    let items = cart.items;
    for (var i = 0; i < items.length; i++) {
      if (productHandles.indexOf(items[i].handle) === -1) {
        productHandles.push(items[i].handle);
      }
    }

    productHandles.forEach(function (value) {
      $(`#product-${value}`).find($(".action .launchtip_upsell_design")).addClass("in-cart");

      $(`#product-${value}`).find($(".action .launchtip_upsell_design")).html(`<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
     	<path d="M15.5916 2L7.81053 10.0431L4.40842 6.54133L2 9.02L7.81053 15L18 4.47867L15.5916 2Z" fill="white" stroke="#218380" stroke-width="2"/>
     	</svg>
		`);
    });
  });

  //modal close icon
  $(".featherlight-close-icon.featherlight-close").html(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.28947 8L0.355267 1.0658L0 0.710534L0.710534 0L1.0658 0.355267L8 7.28947L14.9342 0.355267L15.2895 0L16 0.710534L15.6447 1.0658L8.71053 8L15.6447 14.9342L16 15.2895L15.2895 16L14.9342 15.6447L8 8.71053L1.0658 15.6447L0.710534 16L0 15.2895L0.355267 14.9342L7.28947 8Z" fill="#1B242B"/>
  </svg>
  `);

  //button plus icon
  $(".btn.launchtip_upsell_design").html(`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 6H11" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
  <path d="M6 1L6 11" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
  </svg>
  `);

  //trigger cart drawer when add to cart
  $("#launchtip_upsell_wrapper .add-to-cart.launchtip_add_to_cart:not(disabled)").on("click touchstart", function (e) {
    e.preventDefault();

    productHandles = [];
    setTimeout(function () {
      $("a.js-drawer-open-right")[0].click();

      //check if upsell products in cart, if they are change the icons
      $.getJSON("/cart.js", function (cart) {
        let items = cart.items;
        for (var i = 0; i < items.length; i++) {
          if (productHandles.indexOf(items[i].handle) === -1) {
            productHandles.push(items[i].handle);
          }
        }

        productHandles.forEach(function (value) {
          $(`#product-${value}`).find($(".action .launchtip_upsell_design")).addClass("in-cart");
          $(`#product-${value}`).find($(".action .launchtip_upsell_design")).html(`<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5916 2L7.81053 10.0431L4.40842 6.54133L2 9.02L7.81053 15L18 4.47867L15.5916 2Z" fill="white" stroke="#218380" stroke-width="2"/>
          </svg>`);
        });
      });
    }, 2000);
  });

  //removing products in cart, check if upsell products in cart, if they are change the icons
  $("body").delegate(".ajaxcart .remove-product", "click", function () {
    productHandles = [];

    setTimeout(function () {
      $.getJSON("/cart.js", function (cart) {
        let items = cart.items;
        for (var i = 0; i < items.length; i++) {
          console.log(items[i]);
          if (productHandles.indexOf(items[i].handle) === -1) {
            productHandles.push(items[i].handle);
          }
        }

        $(".btn.launchtip_upsell_design").removeClass("in-cart");
        $(".btn.launchtip_upsell_design").html(`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6H11" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
          <path d="M6 1L6 11" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
          </svg>
          `);

        productHandles.forEach(function (value) {
          $(`#product-${value}`).find($(".action .launchtip_upsell_design")).addClass("in-cart");
          $(`#product-${value}`).find($(".action .launchtip_upsell_design")).html(`<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5916 2L7.81053 10.0431L4.40842 6.54133L2 9.02L7.81053 15L18 4.47867L15.5916 2Z" fill="white" stroke="#218380" stroke-width="2"/>
          </svg>
          `);
        });
      });
    }, 2000);
  });
});

//SellUp app modal custom
$(document).arrive(".featherlight .launchtipsellupform", function () {
  $(".featherlight .launchtipsellupform .launchtip_select_options_div").append($(".featherlight .featherlight-inner .launchtip_add_to_cart"));

  $(".featherlight-close-icon.featherlight-close").html(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.28947 8L0.355267 1.0658L0 0.710534L0.710534 0L1.0658 0.355267L8 7.28947L14.9342 0.355267L15.2895 0L16 0.710534L15.6447 1.0658L8.71053 8L15.6447 14.9342L16 15.2895L15.2895 16L14.9342 15.6447L8 8.71053L1.0658 15.6447L0.710534 16L0 15.2895L0.355267 14.9342L7.28947 8Z" fill="#1B242B"/>
  </svg>
  `);
});

// account mobile active nav reposition
if ($(window).width() < 990) {
  if ($('.account-sidebar__link.active').length) {
    let offset = $('.account-sidebar__link.active').offset().left - 10;
    $('.account-sidebar__links').scrollLeft(offset, 0);
  }
}

// build wishlist product card
function wishlistProductCard() {
  document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function (e) {
    setTimeout(() => {
      if (window.WishListHero_SDK.GetWishListItemsCount() > 0) {
        let wishlistItems = window.WishListHero_SDK.GetWishListItems();
        if ($('.account-wishlist-wrapper').hasClass('account-wishlist-overview')) {
          wishlistItems = wishlistItems.slice(-3);
        }
        else {
          wishlistItems = wishlistItems.slice(-12);
        }
        wishlistItems.forEach((wishlistItem) => {
          $('.account-wishlist-wrapper').prepend(buildWishlistProductCard(wishlistItem));
        });
        wishlistProductCardRemove();
      }
      else {
        $('.account-wishlist-wrapper').prepend('<span class="empty-text">No wishlist items</span>');
      }
    }, 500);
  });
}

// remove wishlist button
function wishlistProductCardRemove() {
  $('.account-wishlist-remove').click(function(e) {
    e.preventDefault();
    window.WishListHero_SDK.DeleteWishListItem({ProductVariantId: $(this).parent('.account-wishlist-item').data('product-variant-id'), WishlistHash: window.WishListHero_SDK.GetWishListHash() });
    location.reload();
  })
}

// build product card layout
function buildWishlistProductCard(item) {

  let wishlistProductCard =
    `<a href="${item.ProductLink}" class="account-wishlist-item" data-product-variant-id=${item.ProductVariantId}>
      <div class="account-wishlist-remove"></div>
      <div class="account-wishlist-image">
        <img src="${item.ProductImage.replace('_small.', '.')}">
      </div>
      <div class="account-wishlist-info">
        <h3 class="account-wishlist-price">$${item.DisplayPrice.toFixed(2)}</h3>
        <h4 class="account-wishlist-name">${item.ProductName}</h4>
      </div>
      <form method="post" action="/cart/add">
        <input name="id" class="form-input-value" value="${item.ProductVariantId}" type="hidden" />
        <button name="add" class="wishlist-addtocart-available" type="submit">ADD TO CART</button>
      </form>
    </a>`;

  $.getJSON(`${item.ProductLink.split('?variant')[0]}.js`, function(product) {
    let productCard =  $(`.account-wishlist-item[data-product-variant-id="${item.ProductVariantId}"]`);
    if (product.variants.length > 1) {
      product.variants.forEach(variant => {
        if(variant.id == item.ProductVariantId) {
          if(!variant.available) {
            productCard.find('button').prop("disabled", true);
            productCard.find('button').text('OUT OF STOCK');
            productCard.find('button').removeClass('wishlist-addtocart-available');
            productCard.addClass('wishlist-card-sold-out');
          }
        }
      });
      if (productCard.find('.form-input-value').val() == item.ProductId) {
        productCard.find('.form-input-value').val(`${product.variants[0].id}`);
      }
    }
    else {
      productCard.find('.form-input-value').val(`${product.variants[0].id}`);
      if (!product.variants[0].available) {
        productCard.find('button').prop("disabled", true);
        productCard.find('button').text('OUT OF STOCK');
        productCard.find('button').removeClass('wishlist-addtocart-available');
        productCard.addClass('wishlist-card-sold-out');
      }
    }
  });
  return wishlistProductCard;
};

// init add wishlist to cart functionality
function wishlistAddToCart() {
  $('body').on('click', '.wishlist-addtocart-available', function() {
    let obj = $(this);
    var form = obj.parent('form');
    obj.text('ADDING...');
    obj.attr('disabled', 'disabled');
    $.post( "/cart/add", $(form).serialize())
    .done(function( data ) {
      document.querySelector('.js-drawer-open-right').click();
      obj.text('ADD TO CART');
      obj.removeAttr('disabled');
    });
    return false;
  });
};

// init custom wishlist
function customWishlistInit() {
  wishlistProductCard();
  wishlistAddToCart();
};

customWishlistInit();

function globalWishlistheroInit() {
  document.arrive(".MuiDialogTitle-root", function (button_element) {
        var svg_element = button_element.querySelector("svg");
    	var newNode = document.createElement("img");
    	newNode.src = "https://cdn.shopify.com/s/files/1/0014/2521/1486/files/Group_33_6dfcfd5d-a983-4165-93b7-543957f4b56e_256x256.png?v=1628494479";
    	newNode.className="wh-pop-logo";
		svg_element.parentNode.insertBefore(newNode, svg_element.nextSibling);
  });

  //if(document.querySelector("#bc-sf-filter-wrapper")){
  //console.log("BoosCommerce search detected ...");
  document.arrive(".wishlist-hero-bc-button", function (wishlistButton) {
    var ev = new CustomEvent("wishlist-hero-add-to-custom-element", {
      detail: wishlistButton,
    });
    document.dispatchEvent(ev);
  });

  function wishlistIconActive(){
    if($('.site-header .wishlist-hero-items-count').css('display') == 'none'){
      //desktop header
      $('.site-header .wishlist-hero-header-icon i').removeClass('wlh-icon-heart');
      $('.site-header .wishlist-hero-header-icon i').addClass('wlh-icon-heart-empty');

      //mobile nav
      $('.mobile-nav__link .wishlist-hero-header-icon i').removeClass('wlh-icon-heart');
      $('.mobile-nav__link .wishlist-hero-header-icon i').addClass('wlh-icon-heart-empty');
    }

    if($('.site-header .wishlist-hero-items-count').text() >= 1 && ($('.wishlist-hero-items-count').css('display') != 'none')){
      //desktop header
      $('.site-header .wishlist-hero-header-icon i').addClass('wlh-icon-heart');
      $('.site-header .wishlist-hero-header-icon i').removeClass('wlh-icon-heart-empty');

      //mobile nav
      $('.mobile-nav__link .wishlist-hero-header-icon i').addClass('wlh-icon-heart');
      $('.mobile-nav__link .wishlist-hero-header-icon i').removeClass('wlh-icon-heart-empty');
    }
  }

  document.arrive(".wishlist-hero-items-count", function(){
    wishlistIconActive();
   
    var wishlistCountMut = new MutationObserver(function(mutations, mut){
      wishlistIconActive();
    });

    wishlistCountMut.observe($(".wishlist-hero-items-count")[0],{
      'attributes': true
    });
  });

  window.setTimeout(function () {
    // console.log("Delayed...");
    document
      .querySelectorAll(".wishlist-hero-bc-button")
      .forEach(function (wishlistButton) {
        var ev = new CustomEvent("wishlist-hero-add-to-custom-element", {
          detail: wishlistButton,
        });
        document.dispatchEvent(ev);
      });
  }, 3000);
};
globalWishlistheroInit();

function cartRecommendationsWidget() {
  //wait until recommendation widget loads
  $(document).arrive(".template-cart .ss-recommendations .bc-addtocart-btn", function () {

    //update cart order table adding recommended products
    $(".bc-addtocart-btn").on('click', function() {
      setTimeout(function() {
        var url = '/cart?' + Date.now() + ' form[action="/cart"]';
        $('#AjaxifyCart').load(url, function() {
          ajaxifyShopify.adjustCart();
          $(".shipping-savings-message-wrapper").load(" .shipping-savings-message-wrapper");
        });
      }, 1200)
    });

  });
};
cartRecommendationsWidget();

// all blog post page scripts
function blogPostScripts() {
  $(document).on('ready', function () {
    if ($('.related-articles .slider .article').length) {
      $('.related-articles .slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Prev.</span></button>',
        nextArrow: '<button class="slick-next"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Next.</span></button>',
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              centerMode: false
            }
          }
        ]
      });
    }
    else {
      $('.related-articles').hide();
    }

    $('.featured-products').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      centerMode: false,
      fade: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            dots: true,
            fade: false
          }
        }
      ]
    });
    $('.featured-products').show();


    $('.related-products').slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      infinite: false,
      autoplay: false,
      rows: 0,
      variableWidth: true,
      prevArrow: '<button class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Prev.</span></button>',
      nextArrow: '<button class="slick-next"><img src="//cdn.shopify.com/s/files/1/0014/2521/1486/files/slider_arrow.svg"/><span>Next.</span></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              variableWidth: false,
              dots: true
          }
        }
      ]
    });
    $('.related-products').show();

  });
}
if ($('.blog-post').length) {
  blogPostScripts();
}